{
  "name": "campaign-frontend",
  "version": "1.0.10",
  "scripts": {
    "build": "ng build",
    "build:version": "node ./scripts/generate-version.js && node ./scripts/generate-i18n-bundle.js && node ./scripts/generate-logo-bundle.js",
    "demo:build-fixtures": "node ./scripts/build-demo-fixtures.js",
    "demo:apply-manual-fixture": "node ./scripts/apply-manual-fixture.js",
    "check:events": "node ./scripts/check-event-enum-usage.js",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "ng": "ng",
    "prebuild": "npm run build:version && npm run check:events",
    "prestart": "npm run build:version && npm run ssl:generate && npm run check:events",
    "prestart:test": "npm run build:version && npm run ssl:generate && npm run check:events",
    "prestart:e2e": "npm run build:version && npm run ssl:generate",
    "pretest": "npm run build:version",
    "prewatch": "npm run build:version",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org shikenso --project campaign_frontend ./dist && sentry-cli sourcemaps upload --org shikenso --project campaign_frontend ./dist",
    "ssl:generate": "./scripts/generate-ssl.sh",
    "start": "rm -rf .angular/cache && ng serve --configuration=local --no-hmr",
    "start:test": "rm -rf .angular/cache && ng serve --configuration=test",
    "start:e2e": "rm -rf .angular/cache && ng serve --configuration=e2e --no-hmr",
    "start:prod": "rm -rf .angular/cache && ng serve --configuration=production",
    "test": "ng test",
    "test:e2e": "playwright test",
    "test:e2e:ui": "playwright test --ui",
    "test:e2e:ui:one": "sh -c 'npm run start:test -- --port 4200 >/tmp/e2e-server.log 2>&1 & wait-on --https-insecure --timeout 240000 https://localhost:4200/campaign-dashboard/ && E2E_USE_EXISTING_SERVER=true E2E_BASE_URL=\"https://localhost:4200/campaign-dashboard/\" playwright test --ui'",
    "watch": "ng build --watch --configuration test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.0.0",
    "@angular/cdk": "^19.0.0",
    "@angular/common": "^19.0.0",
    "@angular/compiler": "^19.0.0",
    "@angular/core": "^19.0.0",
    "@angular/fire": "^19.0.0",
    "@angular/forms": "^19.0.0",
    "@angular/material": "^19.0.0",
    "@angular/material-date-fns-adapter": "^19.0.3",
    "@angular/platform-browser": "^19.0.0",
    "@angular/platform-browser-dynamic": "^19.0.0",
    "@angular/router": "^19.0.0",
    "@angular/service-worker": "^19.2.14",
    "@microsoft/clarity": "^1.0.2",
    "@ngrx/component-store": "^19.0.0-beta.0",
    "@ngx-translate/core": "^16.0.3",
    "@ngx-translate/http-loader": "^16.0.0",
    "@sentry/angular": "^10.12.0",
    "@sentry/cli": "^2.53.0",
    "@sentry/tracing": "^7.120.4",
    "@types/dom-to-image": "^2.6.7",
    "date-fns": "^4.1.0",
    "date-fns-tz": "^3.2.0",
    "dayjs": "^1.11.13",
    "echarts": "^5.6.0",
    "firebase": "^11.2.0",
    "html2canvas-pro": "^1.6.6",
    "lodash": "^4.17.21",
    "ng-dialog-animation": "^9.0.4",
    "ngx-echarts": "^19.0.0",
    "ngx-float-ui": "^19.0.1",
    "ngx-mask": "^20.0.3",
    "ngx-mat-select-search": "^8.0.0",
    "ngx-quill": "^27.0.0",
    "ngx-skeleton-loader": "^11.1.0",
    "ngx-timeago": "^3.0.0",
    "quill": "^2.0.3",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^11.0.3",
    "zone.js": "~0.15.0"
  },
  "overrides": {
    "ng-dialog-animation": {
      "tslib": "^2.3.0",
      "version": "^9.0.4"
    }
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.0.0",
    "@angular-eslint/eslint-plugin": "^18.4.1",
    "@angular-eslint/template-parser": "^18.4.1",
    "@angular/cli": "^19.0.0",
    "@angular/compiler-cli": "^19.0.0",
    "@eslint/js": "^9.15.0",
    "@playwright/test": "^1.57.0",
    "@types/jasmine": "~5.1.0",
    "@types/lodash": "^4.17.13",
    "@types/node": "^20.19.43",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/eslint-plugin": "^8.15.0",
    "@typescript-eslint/parser": "^8.15.0",
    "autoprefixer": "^10.4.20",
    "dotenv": "^17.4.2",
    "eslint": "^8.57.1",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-jsdoc": "^50.5.0",
    "eslint-plugin-prettier": "^5.2.1",
    "eslint-plugin-sonarjs": "^2.0.4",
    "eslint-plugin-typescript-sort-keys": "^3.3.0",
    "jasmine-core": "~5.4.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.4.49",
    "prettier": "^3.4.2",
    "prettier-plugin-organize-imports": "^4.1.0",
    "tailwindcss": "^3.4.15",
    "typescript": "~5.6.2",
    "wait-on": "^9.0.3"
  }
}
